//
//  Check andere websites met deze module of ze delfde pagina hebben.
//  Ja > navigeer naar die pagina, Nee > navigeer naar home
//
document.getElementById('Switcher').addEventListener('change', function(e) {

  e.preventDefault();

  var selectedUrl = this.value;
  if( selectedUrl == '/') return;

  var currentPath = window.location.pathname;
  if( currentPath == '/') currentPath = '';

  jQuery.ajax({
    url: selectedUrl.trim('/') + currentPath,
    type: 'HEAD',
    success: function (data, textStatus, xhr) {
      if (xhr.status === 200) {
        window.location.href = selectedUrl.trim('/') + currentPath;
      } else {
        window.location.href = selectedUrl;
      }
    },
    error: function () {
      window.location.href = selectedUrl;
    }
  });

});